var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownArrowWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17201_17205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50202 4.26883L9.66102 0.223827C9.81009 0.0802282 10.009 0 10.216 0C10.423 0 10.6219 0.0802282 10.771 0.223827C10.8433 0.294179 10.9007 0.378297 10.94 0.471215C10.9792 0.564134 10.9994 0.663969 10.9994 0.764827C10.9994 0.865685 10.9792 0.965521 10.94 1.05844C10.9007 1.15136 10.8433 1.23548 10.771 1.30583L6.05802 5.88783C5.91309 6.02692 5.72114 6.10639 5.52031 6.11047C5.31948 6.11454 5.12447 6.04292 4.97402 5.90983L0.228016 1.30983C0.155497 1.23962 0.0978334 1.15555 0.0584531 1.06261C0.0190727 0.969671 -0.0012207 0.869764 -0.0012207 0.768827C-0.0012207 0.66789 0.0190727 0.567983 0.0584531 0.475045C0.0978334 0.382107 0.155497 0.298036 0.228016 0.227827C0.377093 0.0842279 0.576026 0.00399971 0.783016 0.00399971C0.990006 0.00399971 1.18894 0.0842279 1.33802 0.227827L5.50202 4.26883Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17201_17205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 6.111,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownArrowWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/down_arrow_white.8d7cd653d56364f18a8cf16778730dde.svg";